exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.total-count[data-v-6f8f9a1c] {\r\n  margin-bottom: 12px;\n}\n.filters[data-v-6f8f9a1c] {\r\n  margin-bottom: 12px;\n}\n.c-file[data-v-6f8f9a1c] {\r\n  margin-top: 12px;\n}\n.submit-form-container[data-v-6f8f9a1c] {\r\n  margin-top: 12px;\n}\n.submit-button[data-v-6f8f9a1c] {\r\n  margin-top: 12px;\r\n  color: #fff;\r\n  background: #25d366;\r\n  width: 180px;\r\n  border: none;\n}\r\n", ""]);

// exports
